import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import OrderProp from '../../propTypes/orderProp';
import translate from '../../../../commonComponents/translate';
import DocumentDropZone from '../../../profile/mainPanel/documents/DocumentDropZone';
import DocumentsList from './DocumentsList';

const PDF = 'pdf';

function DocumentsTab(props) {
  const { t, order, onAddDocument, isLoadingBtn, onRemoveClick, wrapperClass } =
    props;
  const { products } = order;

  const productDocuments = useMemo(() => {
    // get only the ones of provider PDF
    const pdfForms = products.filter(
      product => product?.form?.providerType === PDF,
    );

    return (
      pdfForms?.map(product => ({
        _id: `${product?._id}-${product?.form?._id}`,
        documents: {
          originalName: `${product?.product?.name}-${product?.form?.name}`,
          url: product.formAnswersLink,
          ext: PDF,
        },
      })) || []
    );
  }, [products]);

  const opportunityDocuments = useMemo(
    () =>
      order?.documents?.map(doc => ({
        _id: doc.url,
        documents: doc,
      })) || [],
    [order.documents],
  );

  const exitsProductDocuments = useMemo(
    () => productDocuments?.length > 0,
    [productDocuments],
  );

  const [documentToAdd, setDocumentToAdd] = useState([]);

  const handleDocuments = useCallback(
    value => setDocumentToAdd(value),
    [setDocumentToAdd],
  );
  const handleRemove = useCallback(
    () => () => {
      setDocumentToAdd([]);
    },
    [setDocumentToAdd],
  );

  const handleAddDocument = useCallback(() => {
    setDocumentToAdd([]);
    const fullDocuments = [...(order.documents || []), ...documentToAdd];
    onAddDocument({
      documents: fullDocuments,
    });
  }, [setDocumentToAdd, order.documents, documentToAdd, onAddDocument]);

  const btnClasses = cx(
    'btn',
    'm-btn--pill',
    'btn-dynamic',
    'onAddDocument',
    { 'm-loader': isLoadingBtn },
    { 'm-loader--right': isLoadingBtn },
  );

  return (
    <div
      className={`m-portlet m-portlet-rounded opportunity-document-wrapper ${wrapperClass}`}
    >
      {exitsProductDocuments && (
        <DocumentsList
          title={t('documents.product')}
          documents={productDocuments}
        />
      )}
      <DocumentsList
        title={t('uploaded.documents')}
        documents={opportunityDocuments}
        onRemoveClick={onRemoveClick}
      />
      <DocumentDropZone
        key={order.documents}
        documents={documentToAdd}
        docType={{
          name: t('access_session.detail.addDocument'),
          _id: 'docDropzone',
        }}
        handleDocuments={handleDocuments}
        showUploadProgress={() => {}}
        handleUploadLoading={() => {}}
        handleRemove={handleRemove}
        ignoreDocumentTypeId
      />
      <div className="button-container">
        <button
          type="button"
          onClick={handleAddDocument}
          disabled={!documentToAdd || documentToAdd?.length === 0}
          className={btnClasses}
        >
          {t('add.document')}
        </button>
      </div>
    </div>
  );
}

DocumentsTab.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  onAddDocument: PropTypes.func.isRequired,
  isLoadingBtn: PropTypes.bool.isRequired,
  onRemoveClick: PropTypes.func,
};

DocumentsTab.defaultProps = {
  onRemoveClick: null,
};

export default translate(DocumentsTab);
